/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { TimeseriesRainMsUnitEnum } from "./TimeseriesRainMsUnitEnum";
import {
  TimeseriesRainMsUnitEnumFromJSON,
  TimeseriesRainMsUnitEnumFromJSONTyped,
  TimeseriesRainMsUnitEnumToJSON,
  TimeseriesRainMsUnitEnumToJSONTyped,
} from "./TimeseriesRainMsUnitEnum";

/**
 * Mixin for validating "offset"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface TimeseriesSourcesSinks
 */
export interface TimeseriesSourcesSinks {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  values: Array<Array<number>>;
  /**
   * 'm/s' (only option for now)
   *
   * * `m/s` - m/s
   */
  units: TimeseriesRainMsUnitEnum;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the TimeseriesSourcesSinks interface.
 */
export function instanceOfTimeseriesSourcesSinks(value: object): value is TimeseriesSourcesSinks {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("values" in value) || value["values"] === undefined) return false;
  if (!("units" in value) || value["units"] === undefined) return false;
  return true;
}

export function TimeseriesSourcesSinksFromJSON(json: any): TimeseriesSourcesSinks {
  return TimeseriesSourcesSinksFromJSONTyped(json, false);
}

export function TimeseriesSourcesSinksFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesSourcesSinks {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    values: json["values"],
    units: TimeseriesRainMsUnitEnumFromJSON(json["units"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function TimeseriesSourcesSinksToJSON(json: any): TimeseriesSourcesSinks {
  return TimeseriesSourcesSinksToJSONTyped(json, false);
}

export function TimeseriesSourcesSinksToJSONTyped(
  value?: Omit<TimeseriesSourcesSinks, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    interpolate: value["interpolate"],
    values: value["values"],
    units: TimeseriesRainMsUnitEnumToJSON(value["units"]),
    multiplier: value["multiplier"],
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
